import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import { selectLoaded, selectLoading, selectUser } from '../selectors/user.selector';
import { userActions } from '../actions/user.actions';

@Injectable({
    providedIn: 'root',
})
export class UserFacade {
    private store = inject(Store);

    readonly loaded$ = this.store.select(selectLoaded);
    readonly loadedNonNullable$ = this.store.select(selectLoaded).pipe(filter((user) => user !== null));
    readonly loading$ = this.store.select(selectLoading).pipe(filter((data) => data !== null));
    readonly user$ = this.store.select(selectUser);
    readonly userNonNullable$ = this.store.select(selectUser).pipe(filter((user) => user !== null));

    readonly user = this.store.selectSignal(selectUser);

    getUser(): void {
        this.store.dispatch(userActions.getUser());
    }

    clear(): void {
        this.store.dispatch(userActions.clear());
    }
}
